import React from 'react'
import smile from '../data/smile.png'
import cv from '../data/RadhikaMohta.pdf'

export default function Intro() {
  //Vanilla JS projects
  var colors = [
    '#D291BC ',
    '#FEC8D8 ',
    '#FFDFD3 ',
    '#E0BBE4',
    '#957DAD',
    '#FF6961',
    '#FDFD96',
  ]
  var techs = [
    'Javascript',
    'HTML',
    'CSS',
    'Photoshop',
    'React',
    'Redux',
    'C++',
    'Java',
    'Spring',
    'Git',
    'OpenCV',
  ]

  var quotes = [
    `In order to understand recursion,<br/> one must first understand recursion.`,
    'Pivot!',
    `Don’t worry if it doesn’t work right.<br/> If everything did, you’d be out of a job.`,
    `Deleted code<br/> is<br/> debugged code!`,
    'Bazinga!',
    `It’s not a bug – <br/>it’s an undocumented feature.`,
    `A good programmer is someone<br/> who always looks both ways <br/>before crossing a one-way street.`,
    'We were on a break!',
  ]
  function change() {
    var i = 0
    return function () {
      i += 1
      document.getElementById('myBG').style.backgroundColor =
        colors[i % colors.length]
      document.getElementById('mytech').innerHTML = techs[i % colors.length]
    }
  }
  function count(args) {
    var i = 0
    return function () {
      document.getElementById('p1').innerHTML = quotes[i % quotes.length]

      i += args
      if (i < 0) i = quotes.length
    }
  }

  return (
    <>
      <div className='flexbox about'>
        <div
          className='flexbox2 leftabout'
          style={{ marginLeft: '5vw', marginTop: '5vh' }}
        >
          <div
            className='text1'
            style={{
              padding: '3vh 1vw 1vh 3vw',
              color: '#101010',
            }}
          >
            Hello world,
          </div>
          <div
            className='text2'
            style={{
              padding: '1vh 1vw 1vh 3vw',
              color: '#303030',
            }}
          >
            {' '}
            I'm Radhika{' '}
          </div>

          <div
            className='text3'
            style={{
              padding: '1vh 1vw 1vh 3vw',
              color: '#505050',
            }}
          >
            {' '}
            I love designing user centric UX for websites and then use my
            engineering knowledge in creating the UI that I have visualized.{' '}
          </div>
        </div>
        <div
          className='flexbox2 rightabout'
          style={{ marginLeft: '5vw', marginTop: '10vh' }}
        >
          <img className='anim1' src={smile} alt='that is me'></img>
        </div>
      </div>

      <div id='skills' className='flexbox about'>
        <div
          className='flexbox2 leftabout'
          style={{ marginLeft: '5vw', marginTop: '5vh' }}
        >
          <div
            className='text1'
            style={{
              padding: '3vh 1vw 1vh 3vw',
              color: '#101010',
            }}
          >
            {' '}
            Skills
          </div>
          <div
            className='text2'
            style={{
              padding: '1vh 1vw 1vh 3vw',
              color: '#303030',
            }}
          >
            {' '}
            Being a frontend developer I have primary skills such as JS, HTML,
            CSS and ReactJS.
          </div>

          <div
            className='text3'
            style={{
              padding: '1vh 1vw 1vh 3vw',
              color: '#505050',
            }}
          >
            {' '}
            Apart from that, I am a Bachelor's in Technology. Data Structures
            and algorithms are a part of my skillset too. Also, I use C++ and
            Java for my day to day programming activities. I also use Adobe
            Photoshop when I create UX. To know more, click on the card here.{' '}
          </div>
        </div>
        <div className='flexbox2 rightabout'>
          <div style={{ display: 'flex', margin: '2vw' }}>
            <button
              id='change'
              onClick={change()}
              style={{
                marginTop: '10vh',
                marginLeft: '5vw',
                backgroundColor: '#ffffff',
              }}
            >
              <div id='myBG' className='work '>
                <div
                  id='mytech'
                  style={{
                    textAlign: 'center',
                    fontSize: '3vw',
                    height: '5vh',
                  }}
                >
                  Click
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      <div id='interests' className='flexbox about'>
        <div
          className='flexbox2 leftabout'
          style={{ marginLeft: '5vw', marginTop: '5vh' }}
        >
          <div
            className='text1'
            style={{
              padding: '3vh 1vw 1vh 3vw',
              color: '#101010',
            }}
          >
            {' '}
            Interests
          </div>
          <div
            className='text2'
            style={{
              padding: '1vh 1vw 1vh 3vw',
              color: '#303030',
            }}
          >
            {' '}
            I'm a firm believer in the creativity that lies within each
            engineer. The 'art' that we put in 'smart'.
          </div>

          <div
            className='text3'
            style={{
              padding: '1vh 1vw 1vh 3vw',
              color: '#505050',
            }}
          >
            {' '}
            Thus, I practice varied art skills like stenciling and sketching.
            Dancing and singing are my favourite gotos. And I binge watch The
            Big Bang Theory and F.R.I.E.N.D.S too! When not coding, I would edit
            videos and create visually appealing sequences. Or I would be
            attending some hackathon or conference. If not these, I would be
            travelling to the hills. Here is a collection of assorted quotes
            that I live by.{' '}
          </div>
        </div>
        <div
          className='flexbox2 rightabout'
          style={{ marginLeft: '5vw', marginTop: '7vh' }}
        >
          <div
            id='quotes'
            className='flexbox-row work'
            style={{ width: '42vw', marginBottom: '3vh' }}
          >
            <button onClick={count(-1)}>
              <i className='fas fa-chevron-left'></i>
            </button>
            <div id='p1' className='carousel'>
              Change is the only thing constant
            </div>{' '}
            <button onClick={count(1)}>
              <i className='fas fa-chevron-right'></i>
            </button>
          </div>
        </div>
      </div>

      <div id='letstalk' className='flexbox about'>
        <div
          className='flexbox2 leftabout'
          style={{ marginLeft: '5vw', marginTop: '5vh' }}
        >
          <div
            style={{
              padding: '3vw 1vw 1vw 3vw',
              fontSize: '5vw',
              color: '#101010',
            }}
          >
            {' '}
            Let's talk
          </div>
          <div
            className='text2'
            style={{
              padding: '1vw 1vw 1vw 3vw',
              color: '#303030',
            }}
          >
            {' '}
            I'm open to freelancing and to all kinds of website designing
            projects where remote work is a possibility.
          </div>

          <div
            className='text3'
            style={{
              padding: '1vw 1vw 1vw 3vw',
              color: '#505050',
            }}
          >
            {' '}
            I'm socially active so you could find me on LinkedIn where I post
            job related stuffs. Quora for random answers. Also I do love
            programming so there's Leetcode for it. For everything formal, drop
            me a mail. Also, you can get a sneak peek of my attached resume
            there. Feel free to reach out!{' '}
          </div>
        </div>
        <div
          className='flexbox-row rightabout'
          style={{ marginLeft: '5vw', marginTop: '10vh' }}
        >
          <div
            className='talk'
            style={{
              borderRadius: '50%',
            }}
          >
            <embed
              src={cv}
              type='application/pdf'
              frameBorder='0'
              scrolling='auto'
              className='pdf'
            ></embed>
          </div>
          <div className='flexbox2' style={{ marginTop: '10vh' }}>
            <div className='flexitem2' style={{ marginLeft: '0.5vw' }}>
              <a
                href='https://www.linkedin.com/in/radhika-mohta-26885012b/'
                style={{ color: '#202020' }}
              >
                <i className='fab fa-linkedin' />
              </a>
            </div>
            <div className='flexitem2' style={{ marginLeft: '2vw' }}>
              <a href='https://github.com/Radix1' style={{ color: '#202020' }}>
                <i className='fab fa-github' />
              </a>
            </div>
            <div className='flexitem2' style={{ marginLeft: '3vw' }}>
              <a
                href='https://leetcode.com/radhika111/'
                style={{ color: '#202020' }}
              >
                <i className='fas fa-code' />
              </a>
            </div>
            <div className='flexitem2' style={{ marginLeft: '3.2vw' }}>
              <a
                href='https://www.quora.com/profile/Radhika-Mohta-1'
                style={{ color: '#202020' }}
              >
                <i className='fab fa-quora' />
              </a>
            </div>

            <div className='flexitem2' style={{ marginLeft: '2.6vw' }}>
              <a href='tel:+919330193646' style={{ color: '#202020' }}>
                <i className='fab fa-whatsapp'></i>
              </a>
            </div>
            <div className='flexitem2' style={{ marginLeft: '0.7vw' }}>
              <a
                href='mailto:radhikamohta111@gmail.com'
                style={{ color: '#202020' }}
              >
                <i className='fas fa-paper-plane'></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
